import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from '../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const permissionsGroupStartRequest = () => {
  return {
    type: 'PERMISSIONS_GROUP_START_REQUEST'
  };
};

export const permissionsGroupEndRequest = () => {
  return {
    type: 'PERMISSIONS_GROUP_END_REQUEST'
  };
};

export const getAllPermissionsGroupSuccess = ({ data }) => {
  return {
    type: 'PERMISSIONS_GROUP_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllPermissionsGroupError = error => {
  return {
    type: 'PERMISSIONS_GROUP_GET_ALL_ERROR',
    payload: error
  };
};

export const addPermissionsGroupSuccess = ({ data }) => {
  return {
    type: 'PERMISSIONS_GROUP_ADD_SUCCESS',
    payload: data
  };
};

export const addPermissionsGroupError = error => {
  return {
    type: 'PERMISSIONS_GROUP_ADD_ERROR',
    payload: error
  };
};

export const editPermissionsGroupSuccess = ({ data }) => {
  return {
    type: 'PERMISSIONS_GROUP_EDIT_SUCCESS',
    payload: data
  };
};

export const editPermissionsGroupError = error => {
  return {
    type: 'PERMISSIONS_GROUP_EDIT_ERROR',
    payload: error
  };
};

export const removePermissionsGroupSuccess = id => {
  return {
    type: 'PERMISSIONS_GROUP_REMOVE_SUCCESS',
    payload: id
  };
};

export const removePermissionsGroupError = error => {
  return {
    type: 'PERMISSIONS_GROUP_REMOVE_ERROR',
    payload: error
  };
};

export const permissionsGroupModifyStore = ({ data }) => {
  return {
    type: 'PERMISSIONS_GROUP_MODIFY_STORE',
    payload: data
  };
};

export const addPermissionsGroup = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(permissionsGroupStartRequest());
      const response = await api().post('/api/permissions_group', data);
      dispatch(addPermissionsGroupSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'permissionsGroup',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addPermissionsGroupError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(permissionsGroupEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllPermissionsGroup = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(permissionsGroupStartRequest());
      const response = await api().get('/api/permissions_group', { params });
      dispatch(getAllPermissionsGroupSuccess(response));
    } catch (err) {
      dispatch(getAllPermissionsGroupError(err));
    } finally {
      dispatch(permissionsGroupEndRequest());
    }
  };
};

export const editPermissionsGroup = (
  data,
  submitBtn = {},
  handleModalClose
) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(permissionsGroupEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(permissionsGroupStartRequest());
      const id = data._id;
      const response = await api().put('/api/permissions_group/' + id, data);
      dispatch(editPermissionsGroupSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'permissionsGroup',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/permissions_group'));
      }
    } catch (err) {
      dispatch(editPermissionsGroupError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removePermissionsGroup = id => {
  return async dispatch => {
    try {
      dispatch(permissionsGroupStartRequest());
      await api().delete('/api/permissions_group/' + id);
      dispatch(removePermissionsGroupSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'permissionsGroup',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Grupo de permissões removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removePermissionsGroupError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover grupo de permissões.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(permissionsGroupEndRequest());
    }
  };
};

export const restorePermissionsGroup = data => {
  return async dispatch => {
    try {
      dispatch(permissionsGroupStartRequest());
      const id = data._id;
      const response = await api().put('/api/permissions_group/' + id, data);
      dispatch(editPermissionsGroupSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'permissionsGroup',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Grupo de permissões restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editPermissionsGroupError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar grupo de permissões.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(permissionsGroupEndRequest());
    }
  };
};
